import React from 'react';
import { motion } from 'framer-motion';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ReferenceArea } from 'recharts';
export function CommitmentCurveScreen() {
  const data = [{
    name: 'Start',
    readiness: 20,
    complexity: 5
  }, {
    name: 'Early',
    readiness: 70,
    complexity: 15
  }, {
    name: 'Mid',
    readiness: 85,
    complexity: 40
  }, {
    name: 'Late',
    readiness: 90,
    complexity: 75
  }, {
    name: 'Deep',
    readiness: 92,
    complexity: 90
  }];
  return <section className="min-h-screen flex flex-col items-center justify-center bg-slate-50 px-6 py-20" data-id="element-165">
      <div className="max-w-6xl w-full mx-auto flex flex-col items-center" data-id="element-166">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-bold text-slate-900 text-center mb-16" data-id="element-167">
          When users stay, they're ready for more
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="w-full max-w-4xl h-[400px] md:h-[500px] bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-slate-100 mb-16 relative" data-id="element-168">
          <ResponsiveContainer width="100%" height="100%" data-id="element-169">
            <LineChart data={data} margin={{
            top: 20,
            right: 30,
            left: 0,
            bottom: 20
          }} data-id="element-170">
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f1f5f9" data-id="element-171" />
              <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
              fill: '#64748b',
              fontSize: 14,
              fontWeight: 500
            }} dy={10} data-id="element-172" />
              <YAxis hide domain={[0, 100]} data-id="element-173" />
              <Tooltip contentStyle={{
              borderRadius: '8px',
              border: 'none',
              boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
            }} itemStyle={{
              fontWeight: 600
            }} data-id="element-174" />
              <Legend verticalAlign="top" height={36} iconType="circle" wrapperStyle={{
              fontWeight: 500,
              color: '#475569'
            }} data-id="element-175" />

              <ReferenceArea x1="Mid" x2="Late" fill="#F3E8FF" fillOpacity={0.5} data-id="element-176" />

              <Line type="monotone" name="User readiness" dataKey="readiness" stroke="#10B981" strokeWidth={4} dot={{
              r: 6,
              fill: '#10B981',
              strokeWidth: 2,
              stroke: '#fff'
            }} activeDot={{
              r: 8
            }} animationDuration={2000} data-id="element-177" />
              <Line type="monotone" name="Interaction complexity" dataKey="complexity" stroke="#7C3AED" strokeWidth={4} dot={{
              r: 6,
              fill: '#7C3AED',
              strokeWidth: 2,
              stroke: '#fff'
            }} activeDot={{
              r: 8
            }} animationDuration={2000} animationBegin={500} data-id="element-178" />
            </LineChart>
          </ResponsiveContainer>

          {/* Custom Annotation */}
          <motion.div initial={{
          opacity: 0,
          y: -10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 2.5
        }} className="absolute top-14 right-6 md:right-10 bg-purple-100 text-purple-800 px-4 py-2 rounded-lg font-semibold text-sm shadow-sm border border-purple-200 z-10 whitespace-nowrap" data-id="element-179">
            ↙ Introduce interaction HERE
          </motion.div>

          <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 text-slate-400 text-sm font-medium" data-id="element-180">
            Time in experience
          </div>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.8
      }} className="text-xl text-slate-500 text-center font-medium" data-id="element-181">
          Timing matters more than content
        </motion.p>
      </div>
    </section>;
}